export const EVENT_COLORS = {
    DEFECT_COLOR: "#E25984",
    DEFECT_SECONDARY_COLOR: "#FEE0E5",
    WARN_COLOR: "#b1b000",
    WARN_SECONDARY_COLOR: "#ffffcf",
    SUCCESS_COLOR: "#13A13E",
    SUCCESS_SECONDARY_COLOR: "#EEFBF2"
}